import React, { Component } from 'react';
import compose from "lodash/fp/compose";
import Loader from 'components/common/Loader';
import ModalInfo from "../ModalInfo";
import { 
  withTranslation,
  withAccount,
} from "../hoc";
import { withRouterHooks } from '../hoc/withRouterHooks';
import styled, { css } from 'styled-components';
import "./index.css";


const StyledLoader = styled(Loader)`
  margin-left: 20px;
  height: 30px;
  position: relative;
  top: -6px;
`;

class VerifyEmail extends Component {

  constructor(props){
    super(props);

    this.state = {
      verified: false,
      isLoading: true,
      regSuccess: false,
      verifyEmail: true,
    }
  }


  componentDidMount(){
    let code = decodeURI(this.props.location.search);
    if(!code){
      this.props.navigate("/login");
      return;
    }

    this.props.verifyEmail(code)
      .then(data => {
        this.setState({verified: true, isLoading: false});

        // Trigger Google Ads conversion ONLY in production after successful email verification
        if (process.env.NODE_ENV === 'production' && typeof window.gtag === 'function') {
          window.gtag('event', 'conversion', {
            send_to: 'AW-11454726149/najDCJS2ybEaEIWAhdYq',
            transaction_id: code || new Date().getTime().toString(),
          });
          
          console.log('Google Ads conversion triggered: User verified successfully');
        } else if (process.env.NODE_ENV !== 'production') {
          console.log('Development mode: Google Ads conversion NOT triggered');
        }
      })
        
        // Trigger Google Ads conversion ONLY after successful email verification
      //   if (typeof window.gtag === 'function') {
      //     window.gtag('event', 'conversion', {
      //       send_to: 'AW-11454726149/najDCJS2ybEaEIWAhdYq',
      //       transaction_id: code || new Date().getTime().toString(),
      //     });
          
      //     console.log('Google Ads conversion tracked for verified user');
      //   }
      // })
      .catch(err => {
        this.setState({isLoading: false});
        console.error('Email verification failed:', err);
      });
  }

      //   if (this.isRegistrationPage && typeof window.gtag === 'function') {
      //   window.gtag('event', 'conversion', {
      //     send_to: 'AW-11454726149/najDCJS2ybEaEIWAhdYq',
      //   });
      // }

  render() {

    const {
      verified, 
      regSuccess,
      verifyEmail,
      isLoading} = this.state;

    // Show loading state while verifying
    if (isLoading) {
      return (
        <div className="wrapper">
          {/* {loadingData && <StyledLoader />} */}
          <StyledLoader />
        </div>
      );
    }

    return (
      <div className="wrapper">
        {
          <ModalInfo 
            title={"Account Activation Information"}
            verified={verified}
            successInfo={"Your account is activated successfully"}
            errorInfo={"Your account could not be activated"}
            // showBtn={false}
            verifyEmail={verifyEmail}
            regSuccess={regSuccess}
          />
        }
      </div>
    );
  }
}

export default compose(
  withRouterHooks,
  withAccount,
  withTranslation,
)(VerifyEmail);

